import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";
import { useToast } from "./ui/use-toast";

export default function RegisterCard() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [classYear, setClassYear] = useState(new Date().getFullYear());
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const registerRequestsRef = collection(db, 'registerRequests');
      await addDoc(registerRequestsRef, {
        name,
        email,
        classYear: parseInt(classYear), // Ensure it's stored as a number
        timestamp: new Date()
      });

      toast({
        title: "Registration Request Sent",
        description: "Your registration request has been sent. We'll reach out shortly to confirm your information.",
        duration: 5000,
      });

      // Reset form
      setName('');
      setEmail('');
      setClassYear(new Date().getFullYear());
    } catch (error) {
      console.error('Error sending registration request:', error);
      toast({
        title: "Error",
        description: "Failed to send registration request. Please try again.",
        variant: "destructive",
        duration: 5000,
      });
    }

    setIsLoading(false);
  };

  return (
    <Card className="w-[350px] mx-auto mt-10">
      <CardHeader>
        <CardTitle>Register</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-gray-600">
          We apologize for the formalities. If you'd prefer, reach out to a current member of Wayne or an alum already in the portal/receiving emails.
        </div>
        <form onSubmit={handleRegister}>
          <div className="grid w-full items-center gap-4 mt-4">
            <div className="flex flex-col space-y-1.5">
              <Label htmlFor="name">Name</Label>
              <Input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Full Name"
                required
              />
            </div>
            <div className="flex flex-col space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="flex flex-col space-y-1.5">
              <Label htmlFor="classYear">Graduation Year</Label>
              <Input
                id="classYear"
                type="number"
                value={classYear}
                onChange={(e) => setClassYear(parseInt(e.target.value) || new Date().getFullYear())}
                placeholder="Graduation year"
                min="1900"
                max="2100"
                required
              />
            </div>
          </div>
          <div className="text-gray-600 mt-4">
            We'll reach out shortly after you submit this to confirm your information has been added to the database!
          </div>
        </form>
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button type="submit" onClick={handleRegister} disabled={isLoading}>
          {isLoading ? "Sending..." : "Send Registration Request"}
        </Button>
      </CardFooter>
    </Card>
  );
}